import { FC } from 'react';
import { useDragAndDropFilesUpload } from '../hooks';
import { FileDropOverlay } from '@/ui/components/FileDropOverlay';
import { useFileDropZone } from '@/ui/components/useFileDropZone';

export const DropZone: FC = () => {
  const { onFilesStartUpload } = useDragAndDropFilesUpload();
  const { overlayContainerRef, isDragging, error } = useFileDropZone({ onFilesDropped: onFilesStartUpload });

  return (
    <FileDropOverlay
      overlayContainerRef={overlayContainerRef}
      isDragging={isDragging}
      error={error}
      subtitle="Release to add documents to Medical Records"
    />
  );
};
